import type { LibraryItem } from '@pega/cosmos-react-build';

export const nodeLibrary: LibraryItem[] = [
  {
    id: 'decision',
    primary: 'Decision',
    type: {
      icon: { name: 'diamond', category: 'logic', label: 'Decision step logic' }
    }
  },
  {
    id: 'assignment',
    primary: 'Assignment',
    type: {
      icon: { name: 'user-document', category: 'task', label: 'Assignment case type' }
    }
  },
  {
    id: 'automation',
    primary: 'Automation',
    type: {
      icon: { name: 'gear-play', category: 'automation', label: 'Automation object' }
    },
    items: [
      {
        id: 'pdf',
        primary: 'Generate PDF',
        type: {
          icon: { name: 'gear-play', category: 'automation', label: 'Generate PDF object' }
        }
      },
      {
        id: 'sendemail',
        primary: 'Send email',
        type: {
          icon: { name: 'gear-play', category: 'automation', label: 'Send email object' }
        }
      }
    ]
  }
];
